import React from 'react';
import { Button } from 'semantic-ui-react';
import styled from 'styled-components';

import i18n from '@/settings/i18n';

type Props = {
  children?: never;
  isUploading: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const CsvUploadButton: React.FC<Props> = ({ isUploading, onChange }) => (
  <Button as="label" disabled={isUploading} htmlFor="csvUpload" primary={true}>
    <Span>{i18n.t('text.user.index.csvUpload')}</Span>
    <StyledInput type="file" id="csvUpload" onChange={onChange} />
  </Button>
);

const Span = styled.span`
  color: #ffffff;
`;

const StyledInput = styled.input`
  display: none;
`;
